import { render, staticRenderFns } from "./ExEllipsis.vue?vue&type=template&id=5630dc9c"
var script = {}


/* normalize component */
import normalizer from "!../../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports